import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { getOrdersByPerson } from "../ordersThunk";
import { OrdersState } from "../types";
import { CustomError } from "shared/api";

export const getOrdersByPersonReducer = (builder: ActionReducerMapBuilder<OrdersState>) => {
	builder
		.addCase(getOrdersByPerson.pending, state => {
			state.ordersByPerson = [];
			state.loadingOrdersByPerson = true;
		})
		.addCase(getOrdersByPerson.fulfilled, (state, action) => {
			const results = action.payload.results;
			state.ordersByPerson = results;
			state.errorOrdersByPerson = null;
			state.loadingOrdersByPerson = false;
		})

		.addCase(
			getOrdersByPerson.rejected,
			(state, action: PayloadAction<CustomError | undefined>) => {
				if (action.payload) {
					state.errorOrdersByPerson = action.payload;
				}
				state.loadingOrdersByPerson = false;
			},
		)
}